const VoucherRecipients = {
  All: "all",
  SelectedAccounts: "selected-accounts",
  UploadCsv: "upload-csv",
};

export default VoucherRecipients;
